module.exports = {
	"height": 9,
	"infinite": false,
	"layers": [
		{
			"data": [
				111,
				1,
				2,
				3,
				4,
				6,
				3,
				1,
				1,
				1,
				6,
				5,
				3,
				4,
				3,
				112,
				91,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				79,
				77,
				77,
				130,
				91,
				0,
				0,
				0,
				0,
				0,
				78,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				79,
				85,
				105,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				102,
				119,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				116,
				133,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				130,
				94,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				85,
				91,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				102,
				125,
				43,
				45,
				43,
				43,
				48,
				44,
				45,
				43,
				43,
				48,
				43,
				45,
				43,
				46,
				126
			],
			"height": 9,
			"name": "blocking",
			"opacity": 1,
			"type": "tilelayer",
			"visible": true,
			"width": 16,
			"x": 0,
			"y": 0
		},
		{
			"draworder": "topdown",
			"name": "items",
			"objects": [],
			"opacity": 1,
			"type": "objectgroup",
			"visible": true,
			"x": 0,
			"y": 0
		}
	],
	"nextobjectid": 1,
	"orientation": "orthogonal",
	"renderorder": "right-down",
	"templategroups": [],
	"tiledversion": "v1.0.3-214-gc6cfaa0",
	"tileheight": 32,
	"tilesets": [
		{
			"columns": 14,
			"firstgid": 1,
			"image": "../images/sheet.png",
			"imageheight": 320,
			"imagewidth": 448,
			"margin": 0,
			"name": "sheet",
			"spacing": 0,
			"terrains": [
				{
					"name": "Nuovo terreno",
					"tile": -1
				}
			],
			"tilecount": 140,
			"tileheight": 32,
			"tileproperties": {
				"115": {
					"direction": "left",
					"isDoor": true
				},
				"118": {
					"direction": "right",
					"isDoor": true
				}
			},
			"tilepropertytypes": {
				"115": {
					"direction": "string",
					"isDoor": "bool"
				},
				"118": {
					"direction": "string",
					"isDoor": "bool"
				}
			},
			"tilewidth": 32
		}
	],
	"tilewidth": 32,
	"type": "map",
	"version": 1,
	"width": 16
};


//////////////////
// WEBPACK FOOTER
// ./assets/tilemaps/room4.json
// module id = 6rBc
// module chunks = 0